// Les appels du module Annonces. Une route absente (404/501) se dit
// `absent` : l'écran annonce « arrive côté serveur » et n'écrit rien.
import APIService from '../../services/api';

export const BASE = 'https://besoins-tat-production.up.railway.app';
const authH = () => ({ Authorization: `Bearer ${APIService.getToken()}` });

async function repondre(r) {
  if (r.status === 404 || r.status === 501) {
    const j = await r.json().catch(() => ({}));
    // 404 métier (« Annonce introuvable ») ≠ route absente (pas de JSON success).
    if (j && j.success === false && j.error) return { error: j.error, status: r.status };
    return { absent: true, status: r.status };
  }
  const j = await r.json().catch(() => ({}));
  if (!r.ok || j.success === false) return { ...j, error: j.error || `Le serveur a répondu ${r.status}.`, status: r.status };
  return j;
}

export async function lire(chemin) {
  try { return await repondre(await fetch(`${BASE}${chemin}`, { headers: authH() })); }
  catch { return { error: 'Le serveur ne répond pas — réessayez dans un instant.' }; }
}

export async function ecrire(methode, chemin, corps) {
  try {
    return await repondre(await fetch(`${BASE}${chemin}`, {
      method: methode, headers: { ...authH(), 'Content-Type': 'application/json' },
      body: corps === undefined ? undefined : JSON.stringify(corps),
    }));
  } catch { return { error: 'Le serveur ne répond pas — réessayez dans un instant.' }; }
}

export async function deposer(chemin, fichiers) {
  const f = new FormData();
  for (const x of fichiers) f.append('cv', x, x.name);
  try { return await repondre(await fetch(`${BASE}${chemin}`, { method: 'POST', headers: authH(), body: f })); }
  catch { return { error: 'Le serveur ne répond pas — réessayez dans un instant.' }; }
}

export async function copier(texte) {
  try { await navigator.clipboard.writeText(texte); return true; }
  catch {
    try {
      const t = document.createElement('textarea');
      t.value = texte; t.setAttribute('readonly', ''); t.style.position = 'fixed'; t.style.opacity = '0';
      document.body.appendChild(t); t.select();
      const ok = document.execCommand('copy');
      document.body.removeChild(t);
      return ok;
    } catch { return false; }
  }
}

export const dateCourte = (iso) => {
  const d = iso ? new Date(iso) : null;
  return d && !Number.isNaN(d.getTime()) ? d.toLocaleDateString('fr-CH', { day: '2-digit', month: '2-digit', year: 'numeric' }) : '—';
};
